module.exports = __webpack_public_path__ + "img/PRCA2_Myofibroblasts.8bb444a3.png";